import React from 'react';

const CTAComponent = () => {
    return (
        <section data-padding="bottom">
            <div className="infocolors-masked-cta infocolors-masked-block" data-unload="fade-down">
                <form action="mail-short.php" method="post" data-fill-error="Please, fill out the form." className="infocolors-contact-form is-short infocolors-masked-media" data-appear="fade-up">
                    <div className="infocolors-form-content infocolors-cta-form">
                        <div className="infocolors-cta-form-content" data-appear="fade-up" data-delay="100">
                            <div className="infocolors-cta-title">Come along and let us create together.</div>
                            <input type="email" id="subscribe_email" name="subscribe_email" placeholder="the.infocolors@gmail.com" required />
                        </div>
                        <div className="infocolors-cta-form-button" data-appear="fade-up" data-delay="200">
                            <button type="submit">
                                <span className="infocolors-icon infocolors-icon-arrow-submit"></span>
                            </button>
                        </div>
                        <div className="infocolors-contact-form__response"></div>
                    </div>
                    <span className="infocolors-form-spinner"></span>
                </form>
                <div className="infocolors-masked-cta-content infocolors-masked-content at-top-right">
                    <p className="infocolors-large-text" data-appear="fade-down">Where Creativity Meets Vision & The Mind Breeds Inspiration ✨</p>
                </div>
            </div>
        </section>
    );
};

export default CTAComponent;
